import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import 'ant-design-vue/dist/antd.less'
import Antd from 'ant-design-vue'
import Viser from 'viser-vue'
import store from './store'
import pageSize from './store/global.js'
import vSelectPage from 'v-selectpage';
import VDistpicker from 'v-distpicker'
import echarts from 'echarts'
import filters from '@/utils/filter' // global filter
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})
import * as myUtils from '@/utils/util_new'

Vue.use(vSelectPage);
Vue.config.productionTip = false
Vue.prototype.GloPageSize = pageSize
Vue.use(Viser)
Vue.use(Antd)
Vue.component('v-distpicker', VDistpicker)
Vue.prototype.$echarts = echarts
Vue.prototype._MyUtils = myUtils
import roleManagement from '@package/roleManagement'
Vue.use(roleManagement)

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js